var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var session = require('../auth/models/session');
var heading = require('../components/heading');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var io = require('../libs/socketio');
var reportsArray = require('../layout/components/reportsArray');
var auth = require('../auth/models/session');
var Report = Object.assign(require('../../../../models/reports/reportFolder'), Model);
var reportFolderForm = modalForm(Report);
var scheduledReportModal = require('./scheduledReportModal');
var cronstrue = require('cronstrue');
var loadReportRegistry = require('./loadReportRegistry');
var rowActionDropdown = require('../components/rowActionDropdown');

var reports = {};
var MIN_REPORT_DELIVERY_ROWS = 5;

function parseEventConfig(value) {
  if (!value) return {};
  if (typeof value === 'string') {
    try {
      return JSON.parse(value) || {};
    } catch (e) {
      return {};
    }
  }
  return (value && typeof value === 'object') ? value : {};
}

function hasEnabledEventConfig(record) {
  var eventConfig = parseEventConfig(record && record.eventConfig);
  return Boolean(eventConfig && eventConfig.enabled);
}

reports.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Reports';
  header.vm.activeTab('Reports');

  ctrl.scheduledReports = [];
  ctrl.groups = [];
  ctrl.reportTypesByRid = {};
  ctrl.canManageReports = auth.canManageReports();
  ctrl.canManageScheduledReports = auth.canManageScheduledReports();

  ctrl.init = function () {
    return Promise.all([
      loadReportRegistry().catch(function () { return null; }),
      loaders.requestWithLoader({
        url: "api/v1/reportfolder/",
        method: "GET",
      }),
      ctrl.canManageScheduledReports
        ? loaders.requestWithLoader({
            url: "api/v1/scheduledreport/",
            method: "GET",
            loader: 'background'
          }).catch(function () { return []; })
        : Promise.resolve([]),
      loaders.requestWithLoader({
        url: "/api/v1/group/",
        method: "GET",
        loader: 'background'
      }).catch(function () { return []; }),
      loaders.requestWithLoader({
        url: "/api/v1/report/",
        method: "GET",
        loader: 'background'
      }).catch(function () { return []; })
    ]).then(function (result) {
      ctrl.reports = result[1];
      ctrl.scheduledReports = Array.isArray(result[2]) ? result[2] : [];
      ctrl.groups = Array.isArray(result[3]) ? result[3] : [];
      var reportRecords = Array.isArray(result[4]) ? result[4] : [];
      ctrl.reportTypesByRid = reportRecords.reduce(function (acc, record) {
        if (record && record['@rid']) {
          acc[String(record['@rid'])] = record.type || null;
        }
        return acc;
      }, {});
      if (auth.user().isSuperuser == 1) {
        ctrl.reports.push({ name: 'System' })
      }
    })
  }
  
  ctrl.init();
  
  modal.on('closed', ctrl.init);
}

reports.onremove = function () {
  modal.off('closed', this.init);
};

function enqueueReportDownload(uid, reportName) {
  if (!uid || !reportName) return;
  if (typeof reportsArray.track === 'function') {
    reportsArray.track({
      uid: uid,
      status: 'processing',
      reportName: reportName,
      createdAt: Date.now()
    });
    return;
  }
  var existing = reportsArray().find(function (r) { return r.uid == uid; });
  if (!existing) {
    reportsArray().push({
      uid: uid,
      status: 'processing',
      name: reportName,
      timestamp: new Date().toLocaleString()
    });
  }
  m.redraw();
  io.on(uid, function (data) {
    var reportRecord = reportsArray().find(function (r) { return r.uid == (data && data.uid); });
    if (!reportRecord) return;
    if (data.status == 'done' || data.status == 'error') {
      io.off(uid);
      reportRecord.status = data.status;
      reportRecord.url = data.url;
      reportRecord.urls = data.urls;
      reportRecord.files = data.files;
      if (data.errorMessage) reportRecord.errorMessage = data.errorMessage;
    }
    m.redraw();
  });
}

reports.view = function () {
  var ctrl = this
  if (!ctrl.reports){
    return m('div')
  }
  var canManageReports = auth.canManageReports();
  var showReportManagement = edit.vm.editing() || canManageReports;
  return m('div', [
    m(heading, {label: 'Reports', class: 'f-subheadline mh3 mb3 pb1 display'},[
      showReportManagement ? m(rowActionDropdown, {
        items: [
          {
            label: 'New Report Folder',
            icon: 'ion-plus',
            onclick: reportFolderForm.editDialogue.bind(reportFolderForm,{})
          }
        ]
      }) : ''
    ]),
    (() => {
      if (showReportManagement) {
        return m('div.cf', ctrl.reports.filter(r => r.name != 'System').map(function (reportFolder) {
          var reportFolderActions = [];
          var reportFolderRid = reportFolder && reportFolder['@rid'] ? reportFolder['@rid'].toString().slice(1) : null;
          if (auth.user().isSuperuser == 1) {
            reportFolderActions.push({
              label: 'Permissions',
              icon: 'ion-ios-people',
              onclick: function () {
                m.route.set('/reportfolder/' + reportFolderRid + '/permissions');
              }
            });
          }
          reportFolderActions.push(
            {
              label: 'Edit',
              icon: 'ion-ios-compose',
              onclick: reportFolderForm.editDialogue.bind(reportFolderForm, reportFolder)
            },
            {
              label: 'Delete',
              icon: 'ion-ios-trash',
              class: 'red',
              onclick: reportFolderForm.deleteDialogue.bind(reportFolderForm, reportFolder)
            }
          );
          return m('div.grid-item.fl.w-100.w-50-ns.w-25-l.ph3', [
            m('div.flex.justify-between.items-center.ba.bw1.ph2.mb3.pv2', [
              reportFolderRid && !edit.vm.editing()
                ? m(m.route.Link, { href: '/reportfolder/' + reportFolderRid }, reportFolder.name)
                : m('span', reportFolder.name),
              m(rowActionDropdown, {
                items: reportFolderActions
              })
            ])
          ])
        }));
      } else {
        return m('div.cf', ctrl.reports.map(function (reportFolder) {
          if (reportFolder.name != 'System') {
            return m('div.fl.w-100.w-50-ns.w-25-l.ph3.fw3', [
              m(m.route.Link, {href: '/reportfolder/' + reportFolder['@rid'].slice(1)}, [
                m('div.flex.justify-between.items-center.ba.b--mid-gray.bw1.pa2.mb3.f6', [
                  reportFolder.name,
                  m('i.icon.ion-folder')
                ]),
              ])
            ])
          } else {
            return m('div.fl.w-100.w-50-ns.w-25-l.ph3.fw3', [
              m(m.route.Link, {href: '/reportsystem/'}, [
                m('div.flex.justify-between.items-center.ba.b--mid-gray.bw1.pa2.mb3.f6', [
                  'System',
                  m('i.icon.ion-folder')
                ]),
              ])
            ])
          }
        }))
      }
    })(),
    ctrl.canManageScheduledReports ? m('div.mh3.mt4', [
      m(heading, {label: 'Report Delivery', class: 'f-subheadline mb3 pb1 display'}),
      (!ctrl.scheduledReports || ctrl.scheduledReports.length === 0)
        ? m('div.gray.f4', 'No report delivery rules yet.')
        : m('table.w-100.f4', [
          m('colgroup', [
            m('col', {width: '18%'}),
            m('col', {width: '18%'}),
            m('col', {width: '16%'}),
            m('col', {width: '8%'}),
            m('col', {width: '10%'}),
            m('col', {width: '16%'}),
            m('col', {width: '6%'}),
            m('col', {width: '8%'})
          ]),
          m('thead', [
            m('tr', [
              m('th.ph0.pv1.tl', 'Name'),
              m('th.ph0.pv1.tl', 'Report'),
              m('th.ph0.pv1.tl', 'Schedule'),
              m('th.ph0.pv1.tl', 'Format'),
              m('th.ph0.pv1.tl', 'Delivery'),
              m('th.ph0.pv1.tl', 'Receivers'),
              m('th.ph0.pv1.tc', 'Enabled'),
              m('th.ph0.pv1.tl', 'Actions')
            ])
          ]),
          m('tbody', buildReportDeliveryRows(ctrl).map(function (schedule) {
            if (!schedule || !schedule['@rid']) {
              return m('tr', [
                m('td.tl.pv1.truncate', [
                  m('span', { style: { visibility: 'hidden' } }, 'Placeholder')
                ]),
                m('td.tl.pv1.truncate'),
                m('td.tl.pv1.truncate'),
                m('td.tl.pv1.truncate'),
                m('td.tl.pv1.truncate'),
                m('td.tl.pv1.truncate'),
                m('td.tc.pv1', [
                  m('i.f2.ml2.ion-android-checkbox-outline-blank.gray', {
                    style: { visibility: 'hidden' }
                  })
                ]),
                m('td.tl.pv1.nowrap', [
                  m('div', { style: { visibility: 'hidden' } }, [
                    m(rowActionDropdown, { items: [] })
                  ])
                ])
              ]);
            }
            var groups = Array.isArray(schedule.groups) ? schedule.groups : [];
            var groupNames = groups.map(function (rid) {
              var match = ctrl.groups.find(function (g) { return g['@rid'] === rid; });
              return match ? match.name : rid;
            }).filter(Boolean);
            var groupLabel = '—';
            if (groupNames.length === 1) {
              groupLabel = groupNames[0];
            } else if (groupNames.length > 1) {
              groupLabel = groupNames.length + ' groups';
            }
            var scheduleRid = schedule && schedule['@rid'] ? schedule['@rid'].slice(1) : null;
            var isEventTrigger = schedule && schedule.triggerType === 'event';
            var scheduleEnabled = schedule && schedule.scheduleEnabled !== false;
            var hasEventNotifications = Boolean(schedule && schedule.notifyOnNewEvents);
            var scheduleLabel = buildCronDescription(schedule.cron);
            if (isEventTrigger && scheduleEnabled) {
              scheduleLabel = hasEventNotifications ? 'On event + schedule + start notifications' : 'On event + schedule';
            } else if (isEventTrigger) {
              scheduleLabel = hasEventNotifications ? 'On event + start notifications' : 'On event';
            } else if (!scheduleEnabled) {
              scheduleLabel = hasEventNotifications ? 'Event start notifications' : 'Disabled';
            }
            var deliveryValue = schedule && schedule.deliveryMethod ? String(schedule.deliveryMethod).toLowerCase() : 'link';
            var deliveryLabel = deliveryValue === 'attachment'
              ? 'Attachment'
              : (deliveryValue === 'onedrive' ? 'SharePoint' : 'Link');
            var reportLabel = schedule.reportName || schedule.reportRid || '';
            var canManageSchedules = auth.canManageScheduledReports();
            if (schedule && schedule.reportRid && ctrl.reportTypesByRid) {
              var reportRid = String(schedule.reportRid);
              if (reportRid.charAt(0) !== '#') reportRid = '#' + reportRid;
              if (ctrl.reportTypesByRid[reportRid] === 'Custom Export') {
                reportLabel = 'Custom Export';
              }
            }
            return m('tr', [
              m('td.tl.pv1.truncate', schedule.name || schedule.reportName || 'Scheduled Report'),
              m('td.tl.pv1.truncate', reportLabel),
              m('td.tl.pv1.truncate', scheduleLabel),
              m('td.tl.pv1.truncate', schedule.format || ''),
              m('td.tl.pv1.truncate', deliveryLabel),
              m('td.tl.pv1.truncate', groupLabel),
              m('td.tc.pv1', [
                schedule.enabled
                  ? m('i.f2.ml2.ion-android-checkbox-outline.green')
                  : m('i.f2.ml2.ion-android-checkbox-outline-blank.gray')
              ]),
              m('td.tl.pv1.nowrap', canManageSchedules ? [
                m(rowActionDropdown, {
                  items: [
                    {
                      label: 'Download test',
                      icon: 'ion-ios-download',
                      onclick: function () {
                        if (!scheduleRid) return;
                        loaders.requestWithLoader({
                          loader: 'submit',
                          url: '/api/v1/scheduledreport/' + scheduleRid + '/download',
                          method: 'GET'
                        }).then(function (res) {
                          if (!res || !res.uid) {
                            throw new Error('Download failed');
                          }
                          enqueueReportDownload(res.uid, res.reportName || schedule.name || schedule.reportName || 'Scheduled Report');
                        }).catch(function (err) {
                          console.error(err);
                          window.alert('Unable to download report.');
                        });
                      }
                    },
                    {
                      label: 'Edit',
                      icon: 'ion-ios-compose',
                      onclick: function () {
                        var scheduleOptions = Object.assign({}, schedule);
                        if (schedule && schedule.reportRid && ctrl.reportTypesByRid) {
                          var reportRid = String(schedule.reportRid);
                          if (reportRid.charAt(0) !== '#') reportRid = '#' + reportRid;
                          if (ctrl.reportTypesByRid[reportRid]) {
                            scheduleOptions.reportType = ctrl.reportTypesByRid[reportRid];
                          }
                        }
                        if (!schedule || !schedule.reportRid) {
                          scheduledReportModal.editDialogue(scheduleOptions, { submitCallback: ctrl.init });
                          return;
                        }

                        loaders.requestWithLoader({
                          loader: 'background',
                          url: '/api/v1/report/' + String(schedule.reportRid).replace(/^#/, ''),
                          method: 'GET',
                          background: true
                        })
                        .then(function (reportRecord) {
                          scheduleOptions.supportsEventNotifications = hasEnabledEventConfig(reportRecord);
                        })
                        .catch(function () {
                          scheduleOptions.supportsEventNotifications = false;
                        })
                        .finally(function () {
                          scheduledReportModal.editDialogue(scheduleOptions, { submitCallback: ctrl.init });
                        });
                      }
                    },
                    {
                      label: 'Delete',
                      icon: 'ion-ios-trash',
                      class: 'red',
                      onclick: function () {
                        if (!schedule || !schedule['@rid']) return;
                        var ok = window.confirm('Delete this scheduled report?');
                        if (!ok) return;
                        loaders.requestWithLoader({
                          loader: 'submit',
                          url: '/api/v1/scheduledreport/' + schedule['@rid'].slice(1),
                          method: 'DELETE'
                        }).then(ctrl.init);
                      }
                    }
                  ]
                })
              ] : [])
            ])
          }))
        ])
    ])
    : null
  ]);
};

function buildReportDeliveryRows(ctrl) {
  var rows = Array.isArray(ctrl.scheduledReports) ? ctrl.scheduledReports.slice() : [];
  if (rows.length === 0) return rows;
  while (rows.length < MIN_REPORT_DELIVERY_ROWS) {
    rows.push({});
  }
  return rows;
}

function buildCronDescription(cron) {
  if (!cron) return '';
  try {
    return cronstrue.toString(String(cron));
  } catch (e) {
    return 'Invalid cron expression';
  }
}

module.exports = reports;
